class JuulsBackInStock extends HTMLElement{
    
    static tagName = 'back-in-stock';
    
    static selectors = {
        form: 'form'
    }
    
    static modifiers ={
        isLoading: 'is-loading'
    }
    
    static events = {
        submit: 'submit'
    }
    
    constructor(){
        super();
        this.form = this.querySelector(JuulsBackInStock.selectors.form);
        this.domParser = new DOMParser();
    }
    
    connectedCallback(){
        if(this.form){
            this.form.addEventListener(JuulsBackInStock.events.submit, this, {
                once: true
            });
        }
    }
    
    handleEvent(event){
        switch (event.type) {
            case JuulsBackInStock.events.submit:
                event.preventDefault();
                this.handleSubmit();
                break;
        }
    }
    
    async handleSubmit(){
        this.classList.add(JuulsBackInStock.modifiers.isLoading);
        
        try {
            const formData = new FormData(this.form);
            const response = await fetch(location.href, {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const htmlStr = await response.text();
            const html = this.domParser.parseFromString(htmlStr, 'text/html');
            const element = html.querySelector(JuulsBackInStock.tagName);

            if (element) {
                this.innerHTML = element.innerHTML;
            }
        } catch (error) {
            console.error('There was an error submitting the form:', error);
        } finally {
            this.classList.remove(JuulsBackInStock.modifiers.isLoading);
        }
        
    }
}
customElements.define(JuulsBackInStock.tagName, JuulsBackInStock);